import React from 'react'
import {
  CellRenderer,
  LoadingListCellRenderer
} from '../../legacy-design-system/grid'
import { ServerApplication } from './shared'
import { css } from '@emotion/css'
import {
  ApplicationLinkWithTooltip,
  SkeletorApplicationLinkWithTooltip
} from '../application-tooltip'
import { ApplicationsGridCell } from '../applications-grid-cell'

interface GetRendererProps {
  organizationID: string
  isListExpanded: (id: string) => boolean
}

interface RowData {
  applications: ServerApplication[]
  name: string
}

const cellContainerCss = css`
  padding: 0 8px;
  max-width: 100%;
`

const appTooltipCss = css`
  max-width: 120px;
`

export function getApplicationsCellRenderer({
  organizationID
}: GetRendererProps): CellRenderer<RowData> {
  return function render({
    rowData: { applications, name: serverName },
    getCellContentProps
  }) {
    return (
      <div {...getCellContentProps({ className: cellContainerCss })}>
        <ApplicationsGridCell<ServerApplication>
          applicationContext={{ name: serverName, type: 'server' }}
          applications={applications}
          renderApplication={({
            applicationUuid,
            name: applicationName,
            hasInstrumentationConflict
          }) => (
            <ApplicationLinkWithTooltip
              showAttackStatus={false}
              organizationID={organizationID}
              applicationID={applicationUuid}
              applicationName={applicationName}
              truncate
              className={appTooltipCss}
              hasInstrumentationConflict={hasInstrumentationConflict}
            />
          )}
          renderSkeletorApplication={({
            applicationUuid,
            name: applicationName,
            hasInstrumentationConflict
          }) => (
            <SkeletorApplicationLinkWithTooltip
              showAttackStatus={false}
              organizationUuid={organizationID}
              applicationUuid={applicationUuid}
              applicationName={applicationName}
              truncate
              hasInstrumentationConflict={hasInstrumentationConflict}
            />
          )}
        />
      </div>
    )
  }
}

export function loadingApplicationsCellRenderer() {
  return <LoadingListCellRenderer max={1} />
}
